<template>
  <div class="content">
    <div class="lineBox" style="padding-top:10px;border:0px;">
      <span class="h3" style="float:left;margin-top:5px;">Clientes </span>
      <input type="text" placeHolder="Nome ou Sobrenome" style="height:30px;margin-left:20px;float:left;"
             class="inputText inputSearch" v-model="search"/>
      <div @click="clearNameSearch()" style="float:left;margin-top:5px;">
        <OpaIcon name="broom" style="margin-left:5px;cursor:pointer"/>
      </div>
      <button @click="openPushNotificationList()" style="float:right;width:186px;">Criar Notificação em
        Push
      </button>
    </div>
    <div style="display:inline; width: 100%;">
      <div @click="downloadBalanceSheet()" style="cursor:pointer;margin:9px 6px;"><img src="/img/icons/white/download.png"> Baixar Planilha de Clientes</div>
      <div style="float: left; margin-top: 10px;">Foram encontrados <b>{{filteredClients.length}}</b> usuários</div>
      <div style="float: right; margin-top: 10px;">Filtrar clientes pela Data de Cadastro: de
        <input v-model="initialDate" type="date" style="width: auto;">
        até
        <input v-model="finalDate" type="date" style="width: auto;">
        <div @click="clearDateSearch()" style="float: right; margin-left: 5px;">
          <u style="cursor: pointer;">Limpar</u>
        </div>
      </div>
    </div>
    <div class="lineBox" style="margin-top:60px; min-height: 75px; min-width:900px;">
      <div style="padding:10px; ">
        <table class="table" cellpadding="0" cellspacing="0" style="min-width:820px">
          <thead>
          <tr>
            <td>
              <input type="checkbox" v-model="selectAll">
            </td>
            <td>Id</td>
            <td>Nome</td>
            <td>Sobrenome</td>
            <td>CPF</td>
            <td>Telefone</td>
            <td>Email</td>
            <td>Endereços</td>
            <td>Data de Nascimento</td>
            <td>Data de Cadastro</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(user, idx ) in filteredClients" v-bind:key="idx">
            <td>
              <input v-if="checkOneSignalKey(user)" type="checkbox" v-model="pushList" :value="user">
            </td>
            <td>{{user.id}}</td>
            <td>{{user.name}}</td>
            <td>{{user.familyName}}</td>
            <td>{{user.cpf}}</td>
            <td>{{user.phone}}</td>
            <td>{{user.email}}</td>
            <td>
              <ul>
                <li v-for="(a, ida) in user.adresses" v-bind:key="ida">
                  {{a.name}}, {{a.streetNumber}} - {{a.vicinity}} - {{a.city}} - {{a.state}} CEP:
                  {{a.cep}}
                </li>
              </ul>
            </td>
            <td>{{formatDate(user.birthday)}}</td>
            <td>{{formatDate(user.created_at)}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <OpaModal v-model="showPushNotificationList" width="500" height="432" header="Criar Notificação em Push">
      <div style="height: 80%; padding:20px;  horiz-align: center; vertical-align: center;">
        <textarea style="width: 100%; resize: none;" type="text" class="inputText" placeholder="Título"
                  v-model="pushTitle" :maxlength="titleMaxCharacters"></textarea>
        <p>{{(pushTitle ? pushTitle.length : 0)}}/{{titleMaxCharacters}}</p>
        <textarea style="width: 100%; height: 100px; resize: none; text-align:;" class="inputText"
                  placeholder="Mensagem"
                  v-model="pushText" :maxlength="textMaxCharacters"></textarea>
        <p>{{(pushText ? pushText.length : 0)}}/{{textMaxCharacters}}</p>
        <p>A notificação em push será enviada para {{pushList.length}} pessoas</p>
      </div>
      <div class="modal_footer" style="height: 20%; width: 100%;">
        <button class="buttonFlat" style="width:80px; float: right; margin-right: 20px; "
                @click="sendPushNotificationList()">Enviar
        </button>
        <button class="buttonWire" style="width:80px; float: right;margin-right: 10px;"
                @click="closePushNotificationList()">Cancelar
        </button>
      </div>
    </OpaModal>

  </div>
</template>

<script>
  import OpaIcon from '@/components/OpaIcon.vue'
  import {EventBus} from '@/utils/event-bus'
  import axios from 'axios'
  import {mapGetters} from 'vuex'
  import formaters from '@/mixins/formater'
  import OpaModal from '@/components/OpaModal.vue'

  export default {
    name: 'Clients',

    data() {
      return {
        clients: [],
        clientsDateFiltered: [],
        pushList: [],
        search: null,
        showPushNotificationList: false,
        pushTitle: null,
        pushText: null,
        textMaxCharacters: 150,
        titleMaxCharacters: 50,
        initialDate: '',
        finalDate: '',
      }
    },

    created() {
      this.getAllClients()
    },

    computed: {
      ...mapGetters(['getProductApi', 'getOpaApi']),

      filteredClients() {
        let filteredList = this.clients
        if (this.search) {
          filteredList = this.nameSearch()
        }
        if (this.initialDate.length === 10) {
          filteredList = filteredList.filter(client => client.created_at >= this.formatDateToTimestamp(this.initialDate))
        }
        if (this.finalDate.length === 10) {
          filteredList = filteredList.filter(client => client.created_at <= this.formatDateToTimestamp(this.finalDate))
        }
        return filteredList
      },

      selectAll: {
        get: function () {
          return this.filteredClients ? this.pushList.length === this.filteredClients.length : false
        },

        set: function (value) {
          var pushList = []

          if (value) {
            this.filteredClients.forEach(function (user) {
              pushList.push(user)
            })
          }

          this.pushList = pushList
        },
      }
    },

    mixins: [formaters],

    components: {OpaIcon, OpaModal},

    methods: {
      ...mapGetters(['getAdmin', 'getCompany']),

      nameSearch(){
        return this.clients.filter((c) => {
          return c.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
            c.familyName.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        })
      },

      clearNameSearch() {
        this.search = null
      },

      clearDateSearch(){
        this.initialDate = ""
        this.finalDate = ""
      },

      checkOneSignalKey(user) {
        return user.onesignal_ids && user.onesignal_ids.length
      },

      openPushNotificationList() {
        if (this.pushList.length) {
          this.showPushNotificationList = true
        } else {
          EventBus.$emit('showAlert', 'error', 'Por favor, selecione ao menos um usúario para continuar')
        }
      },

      closePushNotificationList() {
        this.showPushNotificationList = false
        this.pushTitle = null
        this.pushText = null
      },

      getAllClients() {
        let vm = this
        EventBus.$emit('showLoading', true)
        axios.get(this.getOpaApi + '/user?companyId=' + this.getCompany().companyId)
          .then((r) => {
            if (r.data) {
              vm.clients = r.data
            } else {
              console.log('no client data')
            }
            EventBus.$emit('showLoading', false)
          })
          .catch((e) => {
            console.log(e)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'error', 'erro ao obter clientes')
          })
      },

      downloadBalanceSheet () {
        EventBus.$emit('showLoading', true)
        axios.get(this.getOpaApi+ '/xls/users?company_id=' + this.getCompany().companyId)
                .then((link) => {
                  console.log(link.data.url)
                  EventBus.$emit('showLoading', false)
                  window.open(link.data.url, '_blank')
                })
                .catch((e) => { console.log('Erro creating xlsx', e); EventBus.$emit('showLoading', false)  })
      },

      async sendPushNotificationList() {
        let vm = this

        if (!vm.pushText || !vm.pushTitle) {
          EventBus.$emit('showAlert', 'error', 'por favor preencha título e mensagem')
          return
        }
        EventBus.$emit('showLoading', true)
        let oneSignalList = []
        console.log(vm.pushList)
        vm.pushList.forEach(user => {
          if (user.onesignal_ids && user.onesignal_ids.length) {
            user.onesignal_ids.forEach(id => {
              oneSignalList.push(id)
            })
          }
        })
        let body = {
          ids: oneSignalList,
          message: vm.pushText,
          title: vm.pushTitle,
          company_id: vm.getCompany().companyId
        }

        try {
          await axios.post(this.getOpaApi + '/notification/push', body)
          EventBus.$emit('showLoading', false)
          EventBus.$emit('showAlert', 'success', 'notificação em push enviado com sucesso')
        } catch (e) {
          console.log(e)
          EventBus.$emit('showLoading', false)
          EventBus.$emit('showAlert', 'error', 'erro ao enviar notificão em push')
        }
        vm.showPushNotificationList = false
        vm.pushTitle = null
        vm.pushText = null
        vm.pushList = []

      }
    }
  }
</script>
